import { Expose, Transform } from "class-transformer";
import { IsEnum, IsInt, IsOptional, IsPostalCode, IsString, Length, Matches } from "class-validator";
import type { Driver } from "./Driver";

enum DriverBeneficiaryRelationship {
    SPOUSE = "Spouse",
    CHILD = "Child",
    PARENT = "Parent",
    SIBLING = "Sibling",
    OTHER = "Other",
}

export class DriverBeneficiary {
    static Relationship = DriverBeneficiaryRelationship;

    @Expose()
    @IsOptional()
    @IsInt()
    id?: number;

    createDate?: Date;
    updateDate?: Date;

    driverId?: number;
    driver?: Driver;

    @Expose()
    @IsString()
    @Length(1, 128)
    name: string;

    @Expose()
    @IsEnum(DriverBeneficiaryRelationship)
    relationship: DriverBeneficiary.Relationship;

    @Expose()
    @IsString()
    @Length(1, 64)
    street: string;

    @Expose()
    @Transform(({ value }) => (value === "" ? null : value))
    @IsOptional()
    @IsString()
    @Length(0, 64)
    street2?: string | null;

    @Expose()
    @IsString()
    @Length(1, 32)
    city: string;

    @Expose()
    @IsString()
    @Matches(/^[A-Z]{2}$/)
    state: string;

    @Expose()
    @IsString()
    @IsPostalCode("any")
    zip: string;
}

// Type-only so it can merge with the decorated class; the runtime enum is the static `Relationship` member
export declare namespace DriverBeneficiary {
    export type Relationship = DriverBeneficiaryRelationship;
}
